<div  style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex pb-0">
        <div class="h6 font-weight-bold pt-1 sm-22">
          <!-- <i class="fa fa-money pr-2 pl-0 primary-text"></i> -->
          <svg class="mr-2 pt-1" width="19" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.54533 10.7499L4.09933 10.0546C4.41293 9.8457 4.62603 9.51627 4.688 9.1446L4.93333 7.68193L7.034 6.18126C7.21313 6.05332 7.31941 5.84672 7.31933 5.6266V5.23993C7.31898 5.01827 7.21082 4.81065 7.02938 4.68332C6.84794 4.55599 6.6159 4.52489 6.40733 4.59993L3.60667 5.59993C2.90472 5.85038 2.2525 6.22276 1.68 6.69993L0.5 7.68193" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M0.5 14.5L2.03333 13.378C2.3611 13.1343 2.75823 13.0018 3.16667 13H7.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 13H9.89467C10.1844 13.0028 10.4441 12.822 10.542 12.5493L11.766 9" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.886 6.22928C9.17902 6.61414 9.64134 6.83187 10.1247 6.81262C10.884 6.81262 11.5 6.35062 11.5 5.78128C11.5 5.21195 10.884 4.75062 10.1247 4.75062C9.36533 4.75062 8.75 4.28862 8.75 3.71862C8.75 3.14862 9.366 2.68728 10.1247 2.68728C10.6081 2.66769 11.0705 2.88549 11.3633 3.27062" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.1245 6.81274V7.50008" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.1245 2V2.68733" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 11H7.5C6.94772 11 6.5 11.4477 6.5 12V12C6.5 12.5523 6.94772 13 7.5 13" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 9H9C8.44772 9 8 9.44772 8 10V10C8 10.5523 8.44772 11 9 11H11.076" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.5 1.5H14.5C15.0523 1.5 15.5 1.94772 15.5 2.5V8C15.5 8.55228 15.0523 9 14.5 9H7" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 3.5V2.5C3.5 1.94772 3.94772 1.5 4.5 1.5H8" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
            Send money
        </div>
        <div class="sendMoney-timeline" style="margin-left: 20%;">
            <ul class="timeline m-0 pt-1 px-5" id="timeline">
                <li class="li complete">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Recipient</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': sendMoneyService.isMarkPurpose}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Purpose</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': sendMoneyService.isMarkTransaction}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Details</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': sendMoneyService.isMarkConfirm}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Confirm</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': sendMoneyService.isMarkComplete}">
                    <div class="status pl-0 px-3 border-0">
                        <p class="sm-12 m-neg color-royalblue border-0">Complete</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
